import React from 'react';
import { AdminDashboard } from './pages/AdminDashboard';
import { Toaster } from 'sonner';
export function App() {
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900" data-id="element-0">
      {/* Main Content */}
      <main data-id="element-1">
        <AdminDashboard data-id="element-2" />
      </main>

      {/* Toast Notifications */}
      <Toaster position="top-right" richColors closeButton data-id="element-3" />
    </div>;
}